import { z } from "zod";

/* Kontaktformular: Anfragen an HandVero, wenn Vero oder die Hilfe nicht weitergeholfen haben. Auch ohne Konto nutzbar. */

export const contactSchema = z.object({
  name: z.string().trim().max(120).optional(),
  email: z.string().trim().max(254).optional(),
  message: z
    .string()
    .trim()
    .min(10, "Bitte beschreiben Sie Ihr Anliegen in ein paar Sätzen, damit wir Ihnen gezielt helfen können.")
    .max(4000, "Die Nachricht ist zu lang. Bitte fassen Sie sich auf höchstens 4000 Zeichen."),
  /** Was zuvor Vero gefragt wurde, damit die Rückfrage entfällt. */
  context: z.string().trim().max(2000).optional(),
  source: z.enum(["website", "vero"]).default("website"),
  /** Lockfeld gegen automatische Formulare: bleibt bei Menschen leer. */
  website: z.string().optional(),
  formMs: z.number().int().optional(),
});
export type ContactInput = z.input<typeof contactSchema>;
